import {
  Paper,
  Typography,
  Switches,
  CardHeader,
  IconAvatar,
  DoneOutlineOutlinedIcon,
} from '@occc-app/design-system';

export const VisibleForCommandCenterFulfillment = () => (
  <Paper>
    <CardHeader
      title={
        <Typography variant='subtitle1' gutterBottom>
          Available for Manual Trigger
        </Typography>
      }
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Allow customer support reps to trigger this loyalty event from the member’s profile
        </Typography>
      }
      action={<Switches name='visibleForCommandCenterFulfillment' data={{}} />}
      avatar={<IconAvatar Icon={DoneOutlineOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
